import FuelVideo from './fuel-video';
export default FuelVideo;
